import type { MessageKey } from "@gioia365/i18n";
import { ApiRequestError } from "../api/http";
import type { Translate } from "./locale";

/**
 * Il testo per un errore delle API, dal suo codice (`errors.<codice>` nei cataloghi) e mai dal messaggio
 * del server; qualunque altro errore vale «Qualcosa non ha funzionato».
 */
export function messageForError(t: Translate, error: unknown): string {
  const key: MessageKey = error instanceof ApiRequestError ? `errors.${error.code}` : "errors.unexpected";
  return t(key);
}
